var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 16,
  viewBox: "0 0 8 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2754",
  "data-name": "Rectangle 2754",
  width: 3,
  height: 16,
  fill: "#898989"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2755",
  "data-name": "Rectangle 2755",
  width: 3,
  height: 16,
  transform: "translate(5)",
  fill: "#898989"
})));
export default __webpack_public_path__ + "static/media/pause-icon.8e587a5d.svg";
export { SvgComponent as ReactComponent };